class SocialFeed extends HTMLElement {
  constructor() {
    super();
    this.sliderElement = null; // DOM element for the slider
    this.splideInstance = null; // Store the Splide instance
    this.initialize = this.initialize.bind(this);

    document.addEventListener("DOMContentLoaded", this.initialize);
    window.addEventListener("resize", this.initialize);
  }

  initialize() {
    // Destroy the existing Splide instance if it exists
    if (this.splideInstance) {
      this.splideInstance.destroy();
      this.splideInstance = null; // Clear the instance
    }

    // Get the slider element
    this.sliderElement = this.querySelector(".social__slider");

    // Initialize the slider if it exists
    if (this.sliderElement) {
      this.initSlider();
    }
  }

  initSlider() {
    const options = {
      classes: {
        arrows: 'splide__arrows your-class-arrows',
        arrow: 'splide__arrow your-class-arrow',
        prev: 'splide__arrow--prev custom-prev',
        next: 'splide__arrow--next custom-next',
      },
      autoWidth: true,
      perMove: 1,
      drag: true,
      pagination: true,
      arrows: true,
      mediaQuery: 'min',
      breakpoints: {
        768: {
          destroy: true, // Prevent slider initialization on small screens
        },
      },
    };

    // Create a new Splide instance and save it
    this.splideInstance = new Splide(this.sliderElement, options).mount();
  }
}

// Define the custom element
customElements.define("social-feed", SocialFeed);
